export interface ChceckResourceAvailableResponse {
	resourceAvailable: boolean;
	resourceType: string;
}

const model: types.models.InputModel = {
	resourceAvailable: ['response.checkResourceAvailableResponse.resourceAvailable', false],
};

export default model;
